import { FeatureParams, SubFeatures, GetValues, FeatureKey } from "./common";

export type MessagingSubFeatures = {
  transactional_channel: "transactional_channel";
  promotional_channel: "promotional_channel";
  zceppa_template: "zceppa_template";
  custom_template: "custom_template";
  transactional_download_report: "transactional_download_report";
  promotional_download_report: "promotional_download_report";
  advance_scheduling: "advance_scheduling";
};

export const MESSAGING_SUBFEATURES: MessagingSubFeatures = {
  transactional_channel: "transactional_channel",
  promotional_channel: "promotional_channel",
  zceppa_template: "zceppa_template",
  custom_template: "custom_template",
  transactional_download_report: "transactional_download_report",
  promotional_download_report: "promotional_download_report",
  advance_scheduling: "advance_scheduling",
};
interface MessagingParams
  extends FeatureParams<"feature_messaging", GetValues<MessagingSubFeatures>> {}
export interface MessagingFeatures
  extends SubFeatures<GetValues<MessagingSubFeatures>> {}

export interface MessagingStructure {
  [key: string]: MessagingParams;
}
